import React, { useState, Fragment } from "react";
import {
  GET_LIST,
  Toolbar,
  SaveButton,
} from "react-admin";
import { Card} from "@material-ui/core";
import dataProviderFactory from "../dataProvider";
import moment from "moment";
import styled from "styled-components";
import moment_tz from "moment-timezone";
import {
  map,
  curry,
  range,
  isNil,
} from "ramda";
import LinearProgress from "@material-ui/core/LinearProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import FormControl from "@material-ui/core/FormControl";
import CustomDatePicker from "./customDatePicker";
import { API_ROOT } from "../api-config";

const styles = {
  container: {
    marginLeft: "0em",
    textAlign: "center",
  },
  rightAlignedCell: { textAlign: "right" },
  leftAlignedCell: { textAlign: "left" },
  centerAlignedCell: { textAlign: "center" },
  title: { backgroundColor: "#ff9800" },
  blackBold: { fontWeight: "bold", color: "black" },
  boldCell: { fontWeight: "bold" },
  widthTable: {
    marginLeft: "30px",
    width: "50%",
  },
  flex: { display: "flex", flexDirection:'column' },
  emailsCard: {padding: '10px 20px', backgroundColor: 'rgb(254 151 0 / 12%)', borderRadius: '4px',
              boxShadow: 'rgb(255 152 0 / 2%) 0px 30px 60px -12px inset, rgb(253 229 193) 0px 18px 36px -18px inset', 
              display: "flex", flexDirection: "row", margin: "20px", width: '50%', flexWrap: 'wrap'}
};

const StartForm = styled.div({
  margin: "30px",
  display: "flex",
  flexDirection: "column",
  width: "30%",
  //   height: "29rem",
  justifyContent: "space-between"
});

let dataSetAll = [];
let dataSetRentals = [];
let yearsArray = [];

class reportRentalsAvgByRange extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      numberOfMonths: 2,
      yearsStart: 2016,
      locationsArray: null,
      locationSearch: null,
      yearsEnd: moment().startOf("year").format("YYYYMMDD"),
      optDateBegin: null,
      optDateEnd: null,
      loading: false,
      showTables: false,
      setLoading: false,
      exportData: [],
      setExportData: [],
      DataSet: [],
      month: moment().startOf("month").format("YYYYMMDD"),
      emailsGroup: null,
    };
  }

  async componentDidMount() {
    moment_tz.tz.setDefault("Europe/Madrid");
    const startDate = moment().format("YYYYMMDD");
    const endDate = moment().format("YYYYMMDD");
    await this.updateState(startDate, endDate, null, null, null);
  }

  updateState = async (startDate, endDate, optDateBegin, optDateEnd) => {
    this.setState({
      isLoading: false,
      startDate,
      endDate,
      month: moment(startDate).format("YYYYMMDD"),
      optDateBegin,
      optDateEnd,
    });
  };

  sortedDayList = (start, end) => {
    const add = (day, offset) => day.clone().add(offset, "days");
    return map(curry(add)(start), range(0, end.diff(start, "days") + 1));
  };

  handleChangeOptE = (eventDate) => {
    this.setState({ optDateEnd: eventDate });
  };

  handleChangeOptB = (eventDate) => {
    this.setState({ optDateBegin: eventDate });
  };

  handleDateTimeChange = (event, fieldName) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!isNil(event)) {
      this.setState({ [fieldName]: event });
    }
  };

  handleChange = () => {
    dataSetRentals = [];
    dataSetAll = [];
    if (
      this.state.optDateBegin !== null &&
      this.state.optDateEnd !== null &&
      this.state.optDateBegin !== "" &&
      this.state.optDateEnd !== ""
    ) {
      this.setState({ exportData: [], loading: true, showTables: true });
      this.getReports();
    }
  };

  async getReports() {

    const eventDateStart = moment(this.state.optDateBegin._d).format("YYYY-MM-DD");
    const eventDateEnd = moment(this.state.optDateEnd._d).format("YYYY-MM-DD");  
    const dataProvider = await dataProviderFactory("rest");
    const reportRental = dataProvider(GET_LIST, "reports/reportAvgRentalRange", {
      filter: {
        dateStart: eventDateStart,
        dateEnd: eventDateEnd,
      },
      pagination: {
        page: 1,
        perPage: 99999,
      },
      sort: { field: this.props.created_at, order: "DESC" },
    });

    reportRental
      .then(async (result) => {
        this.state.loading = false;
        dataSetAll = result.data;
        // Obtenemos una lista de todos los años disponibles
        yearsArray = Array.from(
          new Set(dataSetRentals.map((item) => item.years))
        );

        const dataSet = [
          {
            columns: [
              {
                title: "Client Name ",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
              {
                title: "Email",
                style: {
                  font: { sz: "14", bold: true },
                  fill: { patternType: "solid", fgColor: { rgb: "C0C0C0" } },
                },
                width: { wpx: 125 },
              }, // width in pixels
            ],
            data: dataSetRentals.map((data) => [
              {
                value: data.client_name != null ? data.client_name : "",
                style: { font: { sz: "12" } },
              },
              {
                value: data.email != null ? data.email : "",
                style: { font: { sz: "12" } },
              },
            ]),
          },
        ];

        this.setState({ loading: false, DataSet: dataSet });

        return result.data;
      })
      .catch((error) => {
        this.state.loading = false;
      });
  }


  async getReportsDownload(startDate, endDate) {
    let data = {
      startDate: startDate,
      endDate: endDate,
    };

    const response = await fetch(`${API_ROOT}/reports/download`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.token}`,
      },
      body: JSON.stringify(data),
    });

    let commits = await response.json(); // read response body and parse as JSON

    let a = document.createElement("a");
    document.body.appendChild(a);
    a.setAttribute("style", "display: none");
    // a.href = 'data:' + registro.mimeType + ';base64,' + registro.base64;
    a.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${commits.data}`;
    a.download = `Metrics.xlsx`;
    a.click();
    a.remove();
  }

  render() {
    const {
      isLoading,
      optDateBegin,
      optDateEnd,
    } = this.state;

    const { classes, ...props } = this.props;

    if (isLoading) {
      return (
        <Card>
          <LinearProgress />
        </Card>
      );
    }
    const rentalsAvg = {};
    dataSetAll.forEach(item => {
      if (!rentalsAvg[item.years]) {
        rentalsAvg[item.years] = {years: null, numRentals: null, rentalDays: null, avgLength: null}
      }
      rentalsAvg[item.years].years = item.years;
      rentalsAvg[item.years].numRentals = item.num_rentals;
      rentalsAvg[item.years].rentalDays = item.rental_days;
      rentalsAvg[item.years].avgLength = item.avg_length;
    });

    const PostCreateToolbar = (props) => (
      <Toolbar {...props} style={{ backgroundColor: "transparent" }}>
        <SaveButton
          label="Generate"
          type="submit"
          onClick={this.handleChange}
        />
      </Toolbar>
    );

    return (
      <Card>
        <StartForm>
          <h3>Rentals Report By Range </h3>
          <div style={{display:'flex', flexDirection:'row', margin:'20px'}}>
            <div >
              <FormControl style={{ marginBottom: '10px', marginRight: '10px'}}>
                <CustomDatePicker 
                  onChange={e => this.handleChangeOptB(e)}
                  minDate={'2022-01-01'}
                  selectedDate={
                  optDateBegin && optDateBegin !== "null"
                      ? moment(optDateBegin).format("YYYY-MM-DD")
                      : null
                  }
                  label="Date Begin"
                /> 
              </FormControl>
              
              <FormControl style={{ marginBottom: '10px', marginLeft: '10px'}}>
                <CustomDatePicker
                  onChange={e => this.handleChangeOptE(e)}
                  minDate={'2022-01-01'}
                  selectedDate={
                  optDateEnd && optDateEnd !== "null"
                    ? moment(optDateEnd).format("YYYY-MM-DD")
                    : null
                  }
                  label="Date End"
                />  
              </FormControl>
            </div>
          </div>
          <PostCreateToolbar />
        </StartForm>

        {this.state.showTables ? (
          <div style={styles.flex}>
            <Table style={styles.widthTable}>
              <TableHead>
                <TableRow>
                  <TableCell colSpan={3} style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>
                    <h3> Report Average </h3>
                  </TableCell>
                </TableRow>
                <TableRow style={styles.title}>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>YEAR</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>NUM RENTALS</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>RENTAL DAYS</TableCell>
                  <TableCell style={{ ...styles.centerAlignedCell, ...styles.blackBold}}>AVG. RENTAL DAYS</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.keys(rentalsAvg).map((years) => (
                  <TableRow key={years}>
                    <TableCell style={styles.centerAlignedCell}>
                      {years}
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                        {rentalsAvg[years].numRentals} 
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                        {rentalsAvg[years].rentalDays} 
                    </TableCell>
                    <TableCell style={styles.centerAlignedCell}>
                        {rentalsAvg[years].avgLength} 
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>          
          </div> 
         ) : null}
        <div style={{ marginBottom: "10px" }}></div>
      </Card>
    );
  }
}

export default reportRentalsAvgByRange;



// WEBPACK FOOTER //
// ./src/components/reportRentalsAvgByRange.js